import { useEffect, useRef, useState } from 'react';

const DEFAULT_PROPS = {
    perPage: 10,
    page: 1,
    lastPage: 1,
    to: 1,
    from: 1,
    total: 1,
};

export default function usePagination(props = {}) {
    const initialValues = { ...DEFAULT_PROPS, ...props };

    const [perPage, _setPerPage] = useState(initialValues.perPage);
    const [page, _setPage] = useState(initialValues.page);
    const [lastPage, setLastPage] = useState(initialValues.lastPage);
    const [to, setTo] = useState(initialValues.to);
    const [from, setFrom] = useState(initialValues.from);
    const [total, setTotal] = useState(initialValues.total);

    // Skip callback on mount
    const isFirstRun = useRef(true);

    const setData = (data) => {
        _setPerPage((prevValue) => data.perPage || prevValue);
        _setPage((prevValue) => data.page || prevValue);
        setLastPage((prevValue) => data.lastPage || prevValue);
        setTo((prevValue) => data.to || prevValue);
        setFrom((prevValue) => data.from || prevValue);
        setTotal((prevValue) => data.total || prevValue);
    };

    // Wrap setter so that changing perPage always bumps back to page 1
    const setPerPage = (n) => {
        _setPerPage(n);
        _setPage(1);
    };

    const setPage = (n) => _setPage(n);

    // Fire onChange any time page or perPage changes (but not on mount)
    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }
        if (typeof props.onChange === 'function') {
            props.onChange(page);
        }
    }, [perPage, page]);

    return {
        perPage,
        page,
        lastPage,
        to,
        from,
        total,
        setPerPage,
        setPage,
        setLastPage,
        setTo,
        setFrom,
        setTotal,
        setData,
    };
}
